import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/components/${params.componentID}/topics?`

    if (typeof(params.short) !== 'undefined' && params.short !== null) {
      url = `${url}&short=${params.short}`
    }
    if (typeof(params.paginate) !== 'undefined' && params.paginate !== null) {
      url = `${url}&paginate=${params.paginate}`
    }
    if (typeof(params.active) !== 'undefined' && params.active !== null) {
      url = `${url}&active=${params.active}`
    }
    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({tenantID, componentID, topicID}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/${topicID}`,
      method: 'get'
    })
  },
  store({tenantID, componentID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics`,
      method: 'post',
      data
    })
  },
  update({tenantID, componentID, topicID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/${topicID}`,
      method: 'patch',
      data
    })
  },
  destroy({tenantID, componentID, topicID}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/${topicID}`,
      method: 'delete'
    })
  },
  bulkUpdate({tenantID, componentID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics`,
      method: 'patch',
      data
    })
  },
  addFavorite({tenantID, componentID, topicID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/favorites/${topicID}`,
      method: 'post',
      data
    })
  },
  removeFavorite({tenantID, componentID, topicID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/favorites/${topicID}`,
      method: 'delete',
      data
    })
  },
  copy({tenantID, componentID, topicID}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/copy/${topicID}`,
      method: 'post'
    })
  },
  move({tenantID, componentID, topicID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/components/${componentID}/topics/move/${topicID}`,
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/topics.js